module.exports = "https://r.nearpod.com/assets/media/image/binders-icon-c287cf0020e9bd7a85bf16cdfa5a0bd4.svg";